import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import EventEmitter, {
  TRADING_VIEW_WRAPPER_DATA,
  TRADING_VIEW_WRAPPER_DATA_IS_MAIN_SYMBOL_RETURN_NULL,
  TRADING_VIEW_WRAPPER_DATA_LOADING,
  TRADING_VIEW_WRAPPER_DATA_MAIN_SYMBOL,
  TRADING_VIEW_WRAPPER_DATA_RESET,
  TRADING_VIEW_WRAPPER_DATA_RESOLUTION,
} from '../../../helpers/EventEmitter';

export const WrapperData = () => {
  const timeout = useRef();
  const dataRef = useRef({ dataById: {}, mainSymbol: '', resolution: '' });
  const [loading, setLoading] = useState({});
  const [isMainSymbolReturnNull, setIsMainSymbolReturnNull] = useState(false);

  const getMainSymbolKey = () =>
    `${dataRef.current.mainSymbol}_${dataRef.current.resolution}`;

  const onSetMainSymbol = data => {
    dataRef.current.mainSymbol = data;
  };

  const onSetResolution = data => {
    dataRef.current.resolution = data;
  };

  const onSetData = data => {
    const { dataById, mainSymbol, resolution } = dataRef.current;
    const key =
      data.id === mainSymbol ? `${data.id}_${data.resolution}` : data.id;
    let value = dataById[key];
    if (!value) {
      value = [];
    }
    if (resolution !== data.resolution) {
      dataRef.current.resolution = data.resolution;
    }
    dataRef.current.dataById = { ...dataById, [key]: [...value, data] };
  };

  const onSetLoading = data => {
    const key =
      data.id === dataRef.current.mainSymbol
        ? `${data.id}_${data.resolution}`
        : data.id;
    setLoading(old => ({ ...old, [key]: data.value }));
  };

  const onSetMainSymbolReturnNull = ({ symbol }) => {
    const { mainSymbol } = dataRef.current;
    if (mainSymbol === symbol) {
      setIsMainSymbolReturnNull(true);
    }
  };

  const onReset = ({ isSymbolChange, symbol }) => {
    const { dataById, mainSymbol } = dataRef.current;
    setLoading({});
    setIsMainSymbolReturnNull(false);
    if (isSymbolChange && symbol !== mainSymbol) {
      dataRef.current.dataById = {};
    } else {
      dataRef.current.dataById = Object.keys(dataById).reduce((obj, key) => {
        const [ticker] = key.split('_');
        if (ticker === mainSymbol) return { ...obj, [key]: dataById[key] };
        return obj;
      }, {});
    }
  };

  const onFormatData = (id, times) => {
    const { dataById } = dataRef.current;
    const mainSymbolKey = getMainSymbolKey();
    if (!dataById[id] || !dataById[id].length) return;
    if (id === mainSymbolKey) {
      dataById[id].forEach((item, index) => {
        item.callback && item.callback(_.cloneDeep(item.data));
        dataRef.current.dataById[id][index] = {
          ...item,
          callback: undefined,
        };
      });
      return;
    }
    if (
      !dataById[mainSymbolKey] ||
      !dataById[mainSymbolKey].length ||
      !dataById[mainSymbolKey].some(item => item.data.length > 0)
    ) {
      dataById[id].forEach((item, index) => {
        item.callback && item.callback([]);
        dataRef.current.dataById[id][index] = {
          ...item,
          callback: undefined,
        };
      });
    } else {
      dataById[id].forEach((item, index) => {
        if (isMainSymbolReturnNull && index >= dataById[mainSymbolKey].length) {
          item.callback && item.callback(null);
          dataRef.current.dataById[id][index] = {
            ...item,
            callback: undefined,
          };
          return;
        }

        // const mainSymbolData = dataById[mainSymbolKey][index];
        // const matchData = mainSymbolData
        //   ? mainSymbolData.data.reduce(
        //       (obj, val) => ({ ...obj, [val.time]: { time: val.time } }),
        //       {},
        //     )
        //   : {};
        const matchData = [];
        const otherData = [];

        item.data.forEach(val => {
          if (times.includes(val.time)) {
            // matchData[val.time] = val;
            matchData.push(val);
          } else {
            otherData.push(val);
          }
        });
        if (!matchData.length) {
          // matchData[times[0]] = { time: times[0] };
          matchData.push({ time: times[0] });
        }
        // item.callback && item.callback(_.cloneDeep(Object.values(matchData)));
        item.callback && item.callback(_.cloneDeep(matchData));
        dataRef.current.dataById[id][index] = {
          ...item,
          data: otherData,
          callback: undefined,
        };
      });
    }
  };

  useEffect(() => {
    EventEmitter.subscribe(TRADING_VIEW_WRAPPER_DATA, onSetData);
    EventEmitter.subscribe(TRADING_VIEW_WRAPPER_DATA_LOADING, onSetLoading);
    EventEmitter.subscribe(
      TRADING_VIEW_WRAPPER_DATA_MAIN_SYMBOL,
      onSetMainSymbol,
    );
    EventEmitter.subscribe(
      TRADING_VIEW_WRAPPER_DATA_RESOLUTION,
      onSetResolution,
    );
    EventEmitter.subscribe(
      TRADING_VIEW_WRAPPER_DATA_IS_MAIN_SYMBOL_RETURN_NULL,
      onSetMainSymbolReturnNull,
    );
    EventEmitter.subscribe(TRADING_VIEW_WRAPPER_DATA_RESET, onReset);

    return () => {
      EventEmitter.unsubscribe(TRADING_VIEW_WRAPPER_DATA, onSetData);
      EventEmitter.unsubscribe(TRADING_VIEW_WRAPPER_DATA_LOADING, onSetLoading);
      EventEmitter.unsubscribe(
        TRADING_VIEW_WRAPPER_DATA_MAIN_SYMBOL,
        onSetMainSymbol,
      );
      EventEmitter.unsubscribe(
        TRADING_VIEW_WRAPPER_DATA_RESOLUTION,
        onSetResolution,
      );
      EventEmitter.unsubscribe(
        TRADING_VIEW_WRAPPER_DATA_IS_MAIN_SYMBOL_RETURN_NULL,
        onSetMainSymbolReturnNull,
      );
      EventEmitter.unsubscribe(TRADING_VIEW_WRAPPER_DATA_RESET, onReset);
    };
  }, []);

  useEffect(() => {
    if (timeout.current) {
      clearTimeout(timeout);
    }
    timeout.current = setTimeout(() => {
      const isLoading = Object.values(loading).some(val => val);
      if (!isLoading && Object.keys(loading).length > 0) {
        const { dataById, mainSymbol } = dataRef.current;
        const mainSymbolKey = getMainSymbolKey();
        const mainSymbolTimes = dataById[mainSymbolKey]
          ? dataById[mainSymbolKey]
              .reduce(
                (arr, val) => [...arr, ...val.data.map(item => item.time)],
                [],
              )
              .sort((a, b) => a - b)
          : [];
        Object.keys(dataById).forEach(id => {
          const [ticker] = id.split('_');
          if (ticker !== mainSymbol || id === mainSymbolKey) {
            onFormatData(id, mainSymbolTimes);
          }
        });
      }
    }, 500);
  }, [JSON.stringify(loading)]);

  return null;
};
